import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { glossaryKeys } from '@/shared/lib/query/queryKeys';

import { createGlossaryTermApi } from '@/features/glossary/api/createGlossaryTermApi';
import type { CreateGlossaryTermRequest } from '@/features/glossary/api/createGlossaryTermApi';

export const useCreateGlossaryTerm = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: CreateGlossaryTermRequest) => createGlossaryTermApi(request),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: glossaryKeys.all });
      queryClient.invalidateQueries({ queryKey: glossaryKeys.glossaryTree });
      queryClient.invalidateQueries({ queryKey: glossaryKeys.termsAll() });

      const parentFqn = variables.parent || variables.glossary;
      if (parentFqn) {
        queryClient.invalidateQueries({ queryKey: glossaryKeys.childTerms(parentFqn) });
        queryClient.invalidateQueries({ queryKey: glossaryKeys.termDetailByFqn(parentFqn) });
      }

      notification.success({
        message: NOTIFICATION_MESSAGES.GLOSSARY_TERM_CREATE_SUCCESS,
        placement: 'bottomLeft',
        duration: 3,
      });
    },
  });
};
